import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setChatCollapse, setShowChat } from 'redux-store/redux/slices/gameSettings.slice'

const RightSidebarHeader = () => {
  const dispatch = useDispatch()
  const { isChatCollapse, showChat } = useSelector((state) => state.gameSetting)
  const { chat } = useSelector((state) => state.chat)

  const handleCloseChat = useCallback(() => {
    dispatch(setShowChat(false))
  }, [dispatch])

  // Calculate active users
  const activeUsers = chat?.rows ? new Set(chat.rows.map(item => item.userId)).size : 0

  return (
    <div className='chat-header justify-content-between'>
      <div className='chat-header-section'>
        <div className='button-grp'>
          <button onClick={handleCloseChat} className='close-btn'>
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M18 6L6 18M6 6L18 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </button>
        </div>
      </div>
      <div className='header-buttons-wrap d-flex align-item-center'>
        <div className='flex-grow-1 align-items-center d-flex user-info'>
          <span>Online {activeUsers}</span>
        </div>
      </div>
      <div className='d-flex chat-close-wrap'>
        <button
          onClick={handleCloseChat}
          className='chat-collapse-icon'
          title={isChatCollapse ? 'Expand' : 'Collapse'}
        >
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M9 18L15 12L9 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default React.memo(RightSidebarHeader)
